<div>
    <div id="leftNav" class="mt-3 mb-3 pb-3">
        <div class="pb-3 indexStyle" [ngClass]="{'selectedIndex': currentIndex === constants.indexEHD}">
        <button (click)="switchIndex(constants.indexEHD); $event.preventDefault()" style="cursor:pointer; border: none; background: none;">
            <img src="../assets/EHD.png" width="20" style="margin: 0 10px;" /> Electronic Hearing Docket
        </button>
        </div>

        <div class="pb-3 indexStyle" [ngClass]="{'selectedIndex': currentIndex === constants.indexSDM}">
        <button (click)="switchIndex(constants.indexSDM); $event.preventDefault()" style="cursor:pointer; border: none; background: none;">
            <img src="../assets/SDM.png" width="20" style="margin: 0 10px;" /> Staff Discovery Materials
        </button>
        </div>
    </div>
</div>